import React, { useRef, useState, useContext } from "react";
import { Form } from "@unform/web";
import * as Yup from "yup";
import Input from "@/components/Input";
import InputMask from "@/components/InputMask";
import ModalPopup from "@/components/ModalPopup";
import { HashLink as Link } from "react-router-hash-link";
import { useParams } from "react-router-dom";

import "bootstrap/dist/css/bootstrap-grid.min.css";
import { Container, LabelContainer } from "./styles";

import { api } from "@/services/api";

import { Context } from "@/contexts/AuthContext";

export default function Login() {
	let { type } = useParams();
	const formRef = useRef(null);
	const [submitForm, setSubmitForm] = useState(false);
	const [modalPopup, setModalPopup] = useState(false);
	const [modalContent, setModalContent] = useState({
		title: "",
		content: "",
	});
	const [popupDialog, setPopupDialog] = useState(false);
	const { handleLogin } = useContext(Context);

	async function handleSubmit(data) {
		try {
			// esquema de validacao
			let schema;
			if (type === "merchant") {
				schema = Yup.object().shape({
					cnpj: Yup.string().required("Campo obrigatório"),
					password: Yup.string().required("Campo obrigatório"),
				});
			}

			if (type === "consumer") {
				schema = Yup.object().shape({
					cpf: Yup.string().required("Campo obrigatório"),
					password: Yup.string().required("Campo obrigatório"),
				});
			}

			await schema.validate(data, {
				abortEarly: false,
			});

			handleLoginIn(data);
			formRef.current.setErrors({});
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errorMessages = {};

				err.inner.forEach((error) => {
					errorMessages[error.path] = error.message;
				});

				formRef.current.setErrors(errorMessages);
			}
		}
	}

	function handleLoginIn(data) {
		setSubmitForm(true);

		api.post(`${type}/signin`, data)
			.then((res) => {
				setSubmitForm(false);
				if (res?.data?.status === 200) {
					const {
						notify,
						token,
						expires_in,
						consumer,
						merchant,
					} = res.data;

					handleLogin(
						notify,
						type,
						{ token, expires_in },
						consumer ? consumer : merchant,
					);
				}

				if (res?.data?.status === 203) {
					setPopupDialog(true);
				}

				if (res?.data?.status === 400) {
					setSubmitForm(false);
					setModalPopup(true);
					setModalContent({
						title: "Ocorreu um problema!",
						content: res.data.message,
					});
				}

				if (res?.data?.status === 500) {
					setSubmitForm(false);
					setModalPopup(true);
					setModalContent({
						title: "Ocorreu um problema!",
						content:
							"Ops! Não foi possível atender sua solicitação.",
					});
					console.warn({
						endPoint: "signin",
						error: res.data.validation_errors,
					});
				}

				if (res?.data?.status === 501) {
					setSubmitForm(false);
					setModalPopup(true);
					setModalContent({
						title: "Programa de Fidelidade Gerioox",
						content: res.data.message,
					});
					console.warn({
						endPoint: "signin",
						error: res.data.validation_errors,
					});
				}
			})
			.catch((error) => {
				setSubmitForm(false);
				setModalPopup(true);
				setModalContent({
					title: "Ocorreu um problema!",
					content: "Ops! Não foi possível atender sua solicitação.",
				});
				console.error({ endPoint: "signin", error });
			});
	}

	function handleLoginInReActivate() {
		setSubmitForm(true);
		setPopupDialog(false);

		api.post(`${type}/signin`, {
			cpf: formRef.current.getFieldValue("cpf"),
			password: formRef.current.getFieldValue("password"),
			reactive: 1,
		})
			.then((res) => {
				setSubmitForm(false);
				if (res?.data?.status === 200) {
					const {
						notify,
						token,
						expires_in,
						consumer,
						merchant,
					} = res.data;

					handleLogin(
						notify,
						type,
						{ token, expires_in },
						consumer ? consumer : merchant,
					);
				}

				if (res?.data?.status === 203) {
					setModalContent({
						title: "Programa Fidelidade GERIOOX",
						content: res.data.message,
					});
					setModalPopup(true);
				}

				if (res?.data?.status === 400) {
					setSubmitForm(false);
					setModalPopup(true);
					setModalContent({
						title: "Ocorreu um problema!",
						content: res.data.message,
					});
				}

				if (res?.data?.status === 500) {
					setSubmitForm(false);
					setModalPopup(true);
					setModalContent({
						title: "Ocorreu um problema!",
						content:
							"Ops! Não foi possível atender sua solicitação.",
					});
					console.warn({
						endPoint: "signin",
						error: res.data.validation_errors,
					});
				}

				if (res?.data?.status === 501) {
					setSubmitForm(false);
					setModalPopup(true);
					setModalContent({
						title: "Programa de Fidelidade Gerioox",
						content: res.data.message,
					});
					console.warn({
						endPoint: "signin",
						error: res.data.validation_errors,
					});
				}
			})
			.catch((error) => {
				setSubmitForm(false);
				setModalPopup(true);
				setModalContent({
					title: "Ocorreu um problema!",
					content: "Ops! Não foi possível atender sua solicitação.",
				});
				console.error({ endPoint: "signin", error });
			});
	}

	return (
		<Container className='container-fluid'>
			<ModalPopup
				visible={modalPopup}
				message={modalContent}
				onClick={() => setModalPopup(!modalPopup)}
			/>
			{/* pop-dialog */}
			<div
				className='popup-dialog'
				style={{
					display: popupDialog ? "flex" : "none",
				}}>
				<div className='popup-dialog__content'>
					<dialog open id='favDialog'>
						<section>
							<p>
								Usuário inativo gostaria de reativar sua conta?
							</p>
						</section>
						<menu>
							<button
								className='btn-secundary'
								onClick={() => setPopupDialog(false)}>
								Não
							</button>
							<button
								className='btn-primary'
								onClick={() => handleLoginInReActivate()}>
								Sim
							</button>
						</menu>
					</dialog>
				</div>
			</div>
			{/* // pop-dialog */}
			<div className='row justify-content-lg-center'>
				<div className='col-12 col-lg-11'>
					<div className='row justify-content-lg-center'>
						<div className='col-12 col-lg-4'>
							<header>
								<h1 className='title'>
									{type === "merchant" && (
										<>
											Login <span>lojista</span>
										</>
									)}
									{type === "consumer" && (
										<>
											Login <span>consumidor</span>
										</>
									)}
								</h1>
								<span>Programa Fidelidade GERIOOX</span>
							</header>
						</div>
					</div>

					<div className='row'>
						<div className='d-none d-lg-block col-lg-6 desktop-block pr-lg-4'>
							<div className='row block'>
								<div className='col-7'>
									<h2 className='desktop-title'>
										QUERO ME CADASTRAR!
									</h2>
									{type === "merchant" && (
										<Link
											to={`${process.env.PUBLIC_URL}/cadastro-lojista`}
											className='btn-secundary'>
											CADASTRAR
										</Link>
									)}
									{type === "consumer" && (
										<Link
											to={`${process.env.PUBLIC_URL}/#register`}
											className='btn-secundary'>
											CADASTRAR
										</Link>
									)}
								</div>
							</div>

							{type === "merchant" && (
								<img
									loading='lazy'
									className='img-responsive mb-lg-5'
									src={
										require("@/assets/img/cachorro-gato2@2x.jpg")
											.default
									}
									alt='cachorro gato'
								/>
							)}
							{type === "consumer" && (
								<img
									loading='lazy'
									className='img-responsive mb-lg-5'
									src={
										require("@/assets/img/cachorro-gato@2x.jpg")
											.default
									}
									alt='cachorro gato'
								/>
							)}
						</div>

						<div className='col-12 col-lg-4 pl-lg-4'>
							<h2 className='d-none d-lg-block desktop-title'>
								ACESSAR MEU CADASTRO
							</h2>

							<Form
								ref={formRef}
								name='loginIn'
								onSubmit={handleSubmit}>
								{type === "merchant" && (
									<LabelContainer>
										<InputMask
											label='CNPJ'
											name='cnpj'
											mask='99.999.999/9999-99'
											placeholder='00.000.000/0000-00'
										/>
									</LabelContainer>
								)}

								{type === "consumer" && (
									<LabelContainer>
										<InputMask
											label='CPF'
											name='cpf'
											mask='999.999.999-99'
											placeholder='000.000.000-00'
										/>
									</LabelContainer>
								)}

								<LabelContainer>
									<Input
										label='Senha'
										type='password'
										name='password'
										placeholder='Senha'
									/>
								</LabelContainer>

								<div className='actions'>
									<Link to={`${process.env.PUBLIC_URL}/recuperar-senha/${type}`}>
										Esqueci minha senha
									</Link>

									{/* {type === "consumer" && (
										<Link to={`${process.env.PUBLIC_URL}/update-sigin/${type}`}>
											Já sou participante mas ainda não cadastrei minha senha
										</Link>
									)}

									{type === "merchant" && (
										<Link to={`${process.env.PUBLIC_URL}/update-sigin/${type}`}>
											Já sou participante mas ainda não cadastrei minha senha
										</Link>
									)} */}
								</div>

								<div className='button-group'>
									<button
										className='btn-primary'
										type='submit'
										disabled={submitForm ? "disabled" : ""}>
										{submitForm ? "Entrando" : "ENTRAR"}
									</button>
									<div className='d-lg-none'>
										<span className='text-separator'>
											ou
										</span>
										<p className='small-text'>
											Crie sua conta
										</p>
										{type === "consumer" && (
											<Link
												to={`${process.env.PUBLIC_URL}/#register`}
												className='btn-secundary'>
												CADASTRAR
											</Link>
										)}
										{type === "merchant" && (
											<Link
												to={`${process.env.PUBLIC_URL}/cadastro-lojista`}
												className='btn-secundary'>
												CADASTRAR
											</Link>
										)}
									</div>
								</div>
							</Form>
						</div>
					</div>
				</div>
			</div>
		</Container>
	);
}
